import { nuvemshopService as nps } from './mobilizei/nuvemshop.service';
import { trayService as tps } from './mobilizei/tray.service';
import { mapNuvemProduct, mapNuvemProductArrayWithVariants } from '../utils/mappers/nuvemshop';
import { mapTrayProduct, mapTrayProductArray } from '../utils/mappers/tray';
import _ from 'lodash';
import { PLATFORMS } from '../utils/constants';

export const productsService = {
    getProducts,
    getProductById,
    searchProducts
};

function getProducts(platformId, storeId, options, accessToken) {
    let queryMethod = null;
    let mapperMethod = null;
    if (platformId === PLATFORMS.NUVEMSHOP) {
        queryMethod = nps.getProducts;
        mapperMethod = mapNuvemProductArrayWithVariants;
    } else {
        queryMethod = tps.getProducts;
        mapperMethod = mapTrayProductArray;
    }

    return queryMethod(storeId, options, accessToken).then(response => {
        let data = null;
        
        if (platformId === PLATFORMS.NUVEMSHOP) {
            data = {
                products: mapperMethod(response.data),
                totalCount: response.headers.get('x-total-count')
            }
        } else {
            data = {
                products: mapperMethod(response.Products),
                totalCount: _.get(response, 'paging.total', 0)
            }
        }

        return data;
    })
}

function getProductById(platformId, storeId, productId, accessToken) {
    let queryMethod = null;
    let mapperMethod = null;
    if (platformId === PLATFORMS.NUVEMSHOP) {
        queryMethod = nps.getProductById;
        mapperMethod = mapNuvemProduct;
    } else {
        queryMethod = tps.getProductById;
        mapperMethod = mapTrayProduct;
    }

    return queryMethod(storeId, productId, accessToken).then(response => {
        return mapperMethod(response);
    })
}

function searchProducts(platformId, storeId, options, accessToken) {
    let queryMethod = null;
    let mapperMethod = null;
    if (platformId === PLATFORMS.NUVEMSHOP) {
        queryMethod = nps.searchProducts;
        mapperMethod = mapNuvemProductArrayWithVariants;
    } else {
        queryMethod = tps.searchProducts;
        mapperMethod = mapTrayProductArray;
    }

    return queryMethod(storeId, options, accessToken).then(response => {
        let data = null;
        if (platformId === PLATFORMS.NUVEMSHOP) {
            data = {
                products: mapperMethod(response.data),
                totalCount: response.headers.get('x-total-count')
            }
        } else {
            data = {
                products: mapperMethod(response.Products),
                totalCount: _.get(response, 'paging.total', 0)
            }
        }

        return data;
    })
}